import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more-vertical",
  "use": "more-vertical-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"more-vertical\">\n<circle cx=\"12\" cy=\"12\" r=\"2\" />\n<circle cx=\"12\" cy=\"5\" r=\"2\" />\n<circle cx=\"12\" cy=\"19\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol